import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';
import ReceiptLongOutlinedIcon from '@mui/icons-material/ReceiptLongOutlined';
import EventNoteOutlinedIcon from '@mui/icons-material/EventNoteOutlined';
import AssessmentOutlinedIcon from '@mui/icons-material/AssessmentOutlined';
import HomeWorkOutlinedIcon from '@mui/icons-material/HomeWorkOutlined';
import CardMembershipOutlinedIcon from '@mui/icons-material/CardMembershipOutlined';
import RequestQuoteOutlinedIcon from '@mui/icons-material/RequestQuoteOutlined';
import LayersOutlinedIcon from '@mui/icons-material/LayersOutlined';
import LocalOfferOutlinedIcon from '@mui/icons-material/LocalOfferOutlined';
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';
import InsightsOutlinedIcon from '@mui/icons-material/InsightsOutlined';
import NotificationsNoneOutlinedIcon from '@mui/icons-material/NotificationsNoneOutlined';
import GavelOutlinedIcon from '@mui/icons-material/GavelOutlined';
import ShieldOutlinedIcon from '@mui/icons-material/ShieldOutlined';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';

// `match` lista os prefixos de rota que deixam o item ativo (comparação sem diferenciar maiúsculas).
export const navigationSections = [
    {
        title: 'Visão geral',
        items: [
            { label: 'Dashboard', to: '/dashboard', icon: DashboardOutlinedIcon, match: ['/dashboard'] },
            { label: 'Leads landing page', to: '/LeadsLandingPage', icon: InsightsOutlinedIcon, match: ['/leadslandingpage'] },
        ],
    },
    {
        title: 'Operação contábil',
        items: [
            { label: 'Emitir Nota Fiscal', to: '/EmitirNota', icon: ReceiptLongOutlinedIcon, match: ['/emitirnota'] },
            { label: 'Obrigações', to: '/obrigacoes', icon: EventNoteOutlinedIcon, match: ['/obrigacoes'] },
            { label: 'Demonstrações contábeis', to: '/demonstracoes-contabeis', icon: AssessmentOutlinedIcon, match: ['/demonstracoes-contabeis'] },
            { label: 'Endereço Fiscal', to: '/enderecoFiscal', icon: HomeWorkOutlinedIcon, match: ['/enderecofiscal'] },
        ],
    },
    {
        title: 'Comercial',
        items: [
            { label: 'Assinaturas', to: '/Assinaturas', icon: CardMembershipOutlinedIcon, match: ['/assinaturas'] },
            { label: 'Cobranças', to: '/Cobrancas', icon: RequestQuoteOutlinedIcon, match: ['/cobrancas'] },
            { label: 'Planos', to: '/Planos', icon: LayersOutlinedIcon, match: ['/planos'] },
            { label: 'Descontos', to: '/Descontos', icon: LocalOfferOutlinedIcon, match: ['/descontos', '/descontosusados'] },
            { label: 'Usuários', to: '/Usuarios', icon: PeopleAltOutlinedIcon, match: ['/usuarios', '/admins'] },
            { label: 'Notificações', icon: NotificationsNoneOutlinedIcon, disabled: true, hint: 'Em breve' },
        ],
    },
    {
        title: 'Documentos legais',
        items: [
            { label: 'Termos de uso', to: '/TermosDeUso', icon: GavelOutlinedIcon, match: ['/termosdeuso'] },
            { label: 'Política de Privacidade', to: '/PoliticaDePrivacidade', icon: ShieldOutlinedIcon, match: ['/politicadeprivacidade'] },
            { label: 'Contrato de Plano', to: '/contrato/plano', icon: DescriptionOutlinedIcon, match: ['/contrato/plano'] },
            { label: 'Contrato de Endereço Fiscal', to: '/contrato/enderecoFiscal', icon: ArticleOutlinedIcon, match: ['/contrato/enderecofiscal'] },
        ],
    },
];

export const isItemActive = (item, pathname) => {
    if (!item.match) return false;
    const path = pathname.toLowerCase();
    return item.match.some((prefix) => path === prefix || path.startsWith(`${prefix}/`));
};
